import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MenuContent from './components/MenuContent';

export default function MenuPage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="bg-auto bg-repeat" style={{ backgroundImage: 'url(https://storage.helloreaddy.io/project_files/fbab44cd-04c6-492b-a442-ed8f359ae362/72c694f9-1409-463b-96d1-bc011dfd125d_compressed_14.webp)' }}>
        <MenuContent topPadding />
      </main>
      <Footer />
    </div>
  );
}